if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  // The return-policy acknowledgement must be made during the current visit.
  // Keep it in memory only so a previous visit can never pre-check the box.
  window.__lioraReturnPolicyAgreed = false;

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (cartToken) => ({
        cartToken: cartToken || 'cart',
        checked: false,
        storageKey() {
          return `liora_return_policy_${this.cartToken}`;
        },
        init() {
          // Remove any agreement saved by the previous implementation.
          localStorage.removeItem(this.storageKey());
          this.checked = false;

          this.$watch('checked', (value) => {
            window.__lioraReturnPolicyAgreed = value === true;
            this.save();
          });

          document.addEventListener('eurus:cart:validate', () => {
            if (window.__lioraReturnPolicyAgreed !== true) {
              Alpine.store('xCartHelper').validated = false;
            }
          });
        },
        save() {
          const status = this.checked ? 'agreed' : 'not agreed';
          Alpine.store('xCartHelper').updateCart({
            attributes: {
              'Terms and conditions': status
            }
          });
        }
      }));
    });
  });
}
